module.exports = __webpack_public_path__ + "pattern6.88ab8ad95a8055d0f3dc.png";


//////////////////
// WEBPACK FOOTER
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/assets/images/pattern6.png
// module id = ../../../../../src/assets/images/pattern6.png
// module chunks = styles